import { useIntl } from "react-intl";

import { queries } from "lib/build/dashboards/ltx/queries";
import { Origin } from "lib/build/events";

import { useLastEventByQuery } from "src/features/events";

export function useBmi(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const { formatNumber } = useIntl();
	const event = useLastEventByQuery<number>(queries.bmi);
	return event === undefined
		? { value: "-" }
		: {
				value: formatNumber(event.value),
				timestamp: event.timestamp,
				origin: event.origin
			};
}
